import {ScoreEntity} from "../Entity/ScoreEntity.ts";

export function getScore(quizId: string): ScoreEntity {
	return JSON.parse(localStorage.getItem(quizId) ?? '[]');
}

export function saveScore(score: ScoreEntity): void {
	localStorage.setItem(score.quizId, JSON.stringify(score));
}
